import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import withData from 'util/hoc/with-data';
import styled from 'styled-components';
import Loading from 'components/loading';
import { resolve } from 'library/helpers/path-resolver';
import { Link } from 'library/util/core-router';
import ArrowSvg from 'library/icons/arrow.svg';
import CareerSearch from 'apps/trimble-careers/components/career-search';

import Breadcrumbs, { BreadcrumbItem } from 'components/breadcrumbs';
import ViewedCareers from 'apps/trimble-careers/components/viewed-careers';

import Icons from 'apps/trimble-careers/components/icons/index';

const StyledIndustries = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 810px;
  @media(max-width: 1200px) {
    justify-content: center;
  }
`;
const StyledIndustry = styled.div`
  width: 254px;
  border-top: 10px solid ${props=>props.color};
  border-radius: .25em;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.1), 1px 3px 6px 0 rgba(0,0,0,0.22);
  margin: .5em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1.5em;
  > svg {
    width: 4em;
    height: 4em;
    @media(max-width: 768px) {
      margin-right: 1em;
    }
  }

  @media(max-width: 768px) {
    flex-direction: row;
    border-width: 4px;
    width: 100%;
    justify-content: space-between;
    padding: 1em;
    margin: .5em 1em;
  }
`;
const StyledIndustryHeader = styled.p`
  margin: .25em 0;
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  width: 205px;
  @media(max-width: 768px) {
    font-size: 1.25em;
    text-align: left;
    flex: 1;
  }
`;

const ButtonTextStyle = styled.span`
  @media(max-width: 768px) {
    display: none;
  }
`;
const ButtonArrowStyle = styled.span`
  width: 1.25em;
  height: 1.25em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #004A5E;
  margin-left: .5em;
  opacity: 0.45;
  > svg {
    color: #d9f5f9;
    width: .8em;
    height: .8em;
  }

  @media(max-width: 768px) {
    font-size: 1.5em;
  }
`;

const StyledIndustryLink = styled.a`
  padding: .5em 1.5em;
  text-decoration: none;
  color: #004A5E;
  background: #F3CA4A;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-radius: .25em;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    text-decoration: underline;
    ${ButtonArrowStyle} {
      opacity: 1;
    }
  }

  @media(max-width: 768px) {
    width: auto;
    padding: 0;
    background: transparent;
    margin: 0;
  }
`;

const MapIndustries = ({ name, slug, color='#7B5AB5' }) => {
  const IconComponent = resolve(Icons, slug, Icons.education);
  return (
    <StyledIndustry color={color}>
      <IconComponent color={color} />
      <StyledIndustryHeader>{ name }</StyledIndustryHeader>
      <Link component={StyledIndustryLink} to={`/trimble/${slug}`}>
        <ButtonTextStyle>Explore</ButtonTextStyle>
        <ButtonArrowStyle>
          <ArrowSvg />
        </ButtonArrowStyle>
      </Link>
    </StyledIndustry>
  );
};

MapIndustries.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

const HomePageH1 = styled.h1`
  max-width: 100%;
  text-align: center;
  font-size: 2.25em;
`;

const StyledHomeContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledViewedCareersColumn = styled.div`
  padding: .5em;
  flex: 1 0 357px;
`;

const HomePage = ({ graph_loading, graph_data }) => (
  graph_loading
    ? (
      <Loading />
    )
    : (
      <Fragment>
        <HomePageH1>Learn About Construction Careers</HomePageH1>
        <CareerSearch />
        <StyledHomeContent>
          <StyledIndustries>
            { resolve(graph_data, 'industries', []).map(MapIndustries) }
          </StyledIndustries>
          <StyledViewedCareersColumn>
            <ViewedCareers />
          </StyledViewedCareersColumn>
        </StyledHomeContent>
      </Fragment>
    )
);

HomePage.propTypes = {
  graph_loading: PropTypes.bool,
  graph_data: PropTypes.object
};

HomePage.query = async () => (
  await fetch('https://fmzhs9h4ah.execute-api.us-east-1.amazonaws.com/trimble/industries').then(r=>r.json()).then(r=>({data:{industries:r}})).catch((e)=>{console.error(e);return {}})
);

export default withData(HomePage);
